function setCookie(name : string, value: string, days : number | null = null,
                   secure = false, sameSite : "Strict" | "Lax" | "None" | null = null)
{
    let expires = "";

    if (days != null)
    {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }

    const secureAttr = secure ? "; Secure" : "";
    const sameSiteAttr = sameSite !== null ? `; SameSite=${sameSite}` : "";

    document.cookie = name + "=" + (value || "") + expires + "; path=/" + secureAttr + sameSiteAttr;
}

function getCookie(name : string)
{
    const nameEQ = name + "=";

    const ca = document.cookie.split(';');

    for(const element of ca)
    {
        let c = element;

        while (c.startsWith(' ')) {
            c = c.substring(1,c.length);
        }

        if (c.startsWith(nameEQ)) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
}

function clearCookie(name : string) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const Cookie = () => {
    return
}

Cookie.setCookie = setCookie;
Cookie.getCookie = getCookie;
Cookie.clearCookie = clearCookie;
